import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useCallback,
  useRef,
  useEffect,
} from "react";

import Dialog from "../index";

import { Text } from "./style";

const Alert = ({ listenClose = () => {}, children, message }, ref) => {
  const [state, setState] = useState(null);

  const buttonList = useRef();
  const showAlert = (
    result,
    icon = "alert",
    delay = 3000,
    size = "xs",
    type = "alert",
    cantClose
  ) => {
    console.log("result", result);
    if (result && result.alertButtonList) {
      buttonList.current = result.alertButtonList;
    }
    setState({
      message: result ? result.message || result : "",
      data: result ? result.data : null,
      icon,
      delay,
      size,
      type,
      cantClose,
    });
  };

  useImperativeHandle(
    ref,
    () => ({
      show: showAlert,

      hide: () => {
        onClose();
      },
    }),

    []
  );
  const onClose = useCallback(() => {
    setState(null);
    listenClose();
  }, []);

  useEffect(() => {
    if (message) {
      showAlert(message);
    }
  }, [message]);

  return state ? (
    <Dialog
      type={state.type}
      onClose={onClose}
      size={state.size}
      hideDelay={state.delay}
      icon={state.icon}
      customButtonActions={buttonList.current}
      cantClose={state.cantClose}
    >
      {() => (
        <>
          <Text>{state.message}</Text>
          {children}
        </>
      )}
      {/* {() => <>{children ? children : <Text>{state.message}</Text>}</>} */}
    </Dialog>
  ) : null;
};

export default forwardRef(Alert);
